import { BaseEntityAuditada } from '../models/base-entity-auditada.model';
import { OrgaoJustica } from '../orgao-justica/orgao-justica.model';

export interface FonteDados extends BaseEntityAuditada {
  id: number;
  nome: string;
  url: string;
  usuario: string;
  novaSenha: string;
  tipo: TipoFonteDados;
  observacoes: string;
  extrator: FonteDadosExtrator;
}

export interface FonteDadosExtrator {
  orgaoJustica: OrgaoJustica;
  recebendoMensagens: boolean;
  sistemaProcessual: SistemaProcessual;
  tipoSistemaProcessual: TipoSistemaProcessual;
  instancia: FonteDadosInstancia;
  extratorVersao: string;
  extratorVersaoDataImplantacao: Date;
  extratorTimezone: string;
  conversorVersao: string;
  conversorVersaoDataImplantacao: Date;
  conversorTimezone: string;
  prismaVersao: string;
  prismaVersaoDataImplantacao: Date;
  prismaTimezone: string;
  irisVersao: string;
  irisVersaoDataImplantacao: Date;
  irisTimezone: string;
}

export enum TipoFonteDados {
  EXTRATOR = <any>'EXTRATOR',
  INTEGRACAO = <any>'INTEGRACAO',
}

export enum SistemaProcessual {
  PJE = 'PJE',
  PJE_JT = 'PJE_JT',
  PJE_JE = 'PJE_JE',
  PJE_1X = 'PJE_1X',
  PROJUDI = 'PROJUDI',
  SAJ = 'SAJ',
  EPROC = 'EPROC',
  APOLO = 'APOLO',
  THEMIS = 'THEMIS',
  LIBRA = 'LIBRA',
  SCPV = 'SCPV',
  DCP = 'DCP',
  EJUD = 'EJUD',
  TUCUJURIS = 'TUCUJURIS',
  SIAJ = 'SIAJ',
  OUTROS = 'OUTROS',
}

export const SISTEMAS_PROCESSUAIS_ELETRONICOS = [
  SistemaProcessual.PJE,
  SistemaProcessual.PROJUDI,
  SistemaProcessual.EPROC,
  SistemaProcessual.EJUD,
  SistemaProcessual.TUCUJURIS,
  SistemaProcessual.SIAJ,
];

export enum TipoSistemaProcessual {
  ELETRONICO = 'ELETRONICO',
  FISICO = 'FISICO',
  HIBRIDO = 'HIBRIDO',
}

export enum FonteDadosInstancia {
  PRIMEIRO_GRAU = 'PRIMEIRO_GRAU',
  SEGUNDO_GRAU = 'SEGUNDO_GRAU',
  TERCEIRO_GRAU = 'TERCEIRO_GRAU',
  QUARTO_GRAU = 'QUARTO_GRAU',
  MISTO = 'MISTO',
}

export enum MicroServico {
  EXTRATOR = 'EXTRATOR',
  CONVERSOR = 'CONVERSOR',
  IRIS = 'IRIS',
  PRISMA = 'PRISMA',
}
